import { Chat } from "@/entities/chat";
import { Message } from "@/entities/message";
import { useFilterStore } from "@/features/chat/model";
import { apiClient, ApiResponse } from "@/shared/api";

export const searchChats = ({
  query,
  page = 1,
}: {
  query?: string;
  page?: number;
}): Promise<ApiResponse<Chat[]>> => {
  const { readed, registered } = useFilterStore.getState().getActiveFilters();

  const params = new URLSearchParams();

  if (query) {
    params.append("query", query);
  }
  params.append("page", page.toString());
  params.append("limit", "50");

  if (readed !== undefined) {
    params.append("readed", readed.toString());
  }

  if (registered !== undefined) {
    params.append("registered", registered.toString());
  }

  const queryString = params.toString();
  return apiClient(`/api/search/chats?${queryString}`, "get");
};

export const searchMessages = ({
  chatId,
  query,
  page = 1,
}: {
  chatId?: string;
  query?: string;
  page?: number;
}): Promise<ApiResponse<Message[]>> => {
  return apiClient(`/api/search/chats/${chatId}/messages?query=${query}&page=${page}&limit=50`, "get");
};